
<div class="content-box">
  <h3>Ansprechpartner @if (contact?.active === false) {
    <span class="label label-danger">Gelöscht</span>
  }</h3>

  <div class="customer-inside">
    @if (contact) {
      <div>
        {{ contact.title }}
        <h4>{{ contact.first_name }} {{ contact.last_name }}</h4>
        @if (contact.departments.length > 0) {
          <p>
            {{ contact.departments|JoinStringPipe }}
          </p>
        }
        @if (contact.position) {
          <p>
            {{ contact.position }}
          </p>
        }
        @if (contact.phone) {
          <p><i class="fa fa-phone"></i>
          {{ contact.phone }}
        </p>
      }
      @if (contact.mobile) {
        <p><i class="fa fa-mobile"></i>
        {{ contact.mobile }}
      </p>
    }
    @if (contact.mail) {
      <p>
        <a [href]="'mailto:' + contact.mail"
          ngbTooltip="E-Mail an Ansprechpartner senden">
          <i class="fa fa-envelope"></i> {{ contact.mail }}
        </a>
      </p>
    }
  </div>
}
@if (!contact) {
  <div class="customer-inside">
    Kein Ansprechpartner ausgewählt
  </div>
}
</div>

<div class="btn-group content-box-bottom">
  @if (('task.offer.change'|HasPerm)) {
    <button class="btn btn-default btn-sm" (click)="switchContact()">
      Bearbeiten
    </button>
  }
</div>
</div>
